import DOMPurify from 'dompurify';
import { Box, type BoxProps } from '@chakra-ui/react';

/**
 * Renders managed content HTML, sanitized client-side with DOMPurify as defence in
 * depth (the backend already sanitizes on write). Basic typographic styling for
 * paragraphs, lists, links, and images.
 */
export function RenderedHtml({ html, ...rest }: { html: string } & BoxProps) {
  const clean = DOMPurify.sanitize(html ?? '');
  return (
    <Box
      dangerouslySetInnerHTML={{ __html: clean }}
      sx={{
        '& p': { mb: '8px' },
        // scrollMarginTop keeps #anchor jumps (e.g. /terms#account-deletion) clear
        // of the sticky marketing header.
        '& h2': { fontWeight: 700, fontSize: 'xl', mb: '8px', scrollMarginTop: { base: '84px', xl: '104px' } },
        '& ul, & ol': { pl: '20px', mb: '8px' },
        '& a': { color: 'onboarding.roseDeep', textDecoration: 'underline' },
        '& img': { maxWidth: '100%', borderRadius: '8px' },
      }}
      {...rest}
    />
  );
}
